export default __webpack_public_path__ + "static/media/righteye.5453a93d.svg";